import React, { useEffect } from "react"
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
// import '../../static/animation.css';
import '../../static/index.css'

import Layout from "../components/layout"
import SEO from "../components/seo"
import Intro from "../components/intro"
import About from "../components/about"
import Experties from "../components/experties"
import Technologies from "../components/Technologies"
import Contact from "../components/contact"
// import Balloons from "../components/Balloons"

export default () => {
    return <Layout>
        {/* <Balloons /> */}
        <SEO />
        <Intro />
        <About />
        <Experties />
        <Technologies />
        <Contact />
    </Layout>
}
